import { IncomingMessage } from 'http';

import { GetServerSideProps } from 'next';

import Article from 'components/Article';
import { ContactUsPage } from 'utils/remote-config/properties';
import { getServerSideProps as articleSSP } from 'pages/[market]/[vertical]/article/[articleslug]';
import resolveUseContactForm from 'utils/remote-config/resolveContactUsPage';

const shouldUseContactPage = async (req: IncomingMessage, marketCode: string, vertical: string | undefined) => {
  const config = await resolveUseContactForm(req, marketCode, vertical);
  return config === ContactUsPage.CONTACT_ARTICLE;
};

export const getServerSideProps: GetServerSideProps = async context => {
  const { req, query } = context;

  const market = query.market as string;
  const useContactPage = await shouldUseContactPage(req, market, query.vertical as string);

  if (useContactPage) {
    return articleSSP({ ...context, query: { ...query, articleslug: 'contact-us' } });
  }
  return {
    redirect: {
      destination: `/${market}/contact-form/`,
      permanent: false,
    },
  };
};

export default Article;
